"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AllowedGLCodings {
}
exports.AllowedGLCodings = AllowedGLCodings;
//# sourceMappingURL=AllowedGLCodings.js.map